import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Parse from "parse";

import { useGame } from "../header/GameContext";
import Header from "../header/header";
import { saveToSheet } from "../../api/sheet";

import "./clear.css";

//IMG import
import malangImg from "../../img/game/img_malang.png";

//유저 정보 가져오기
const getSharedUserData = async (playerKeyCode) => {
  try {
    const query = new Parse.Query(Parse.Object.extend("skzmalang"));
    query.equalTo("user_key", playerKeyCode);
    const user = await query.first();
    return user;
  } catch (e) {
    console.error("유저 정보 가져오기 실패:", e);
    return null;
  }
};

export default function Clear() {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const sharedKeyCode = searchParams.get("code");
  const isSharedView = !!sharedKeyCode;

  const { playerName, playerKeyCode } = useGame();

  const [sharedUserData, setSharedUserData] = useState(null);

  // 공유링크로 접근 시 DB에서 데이터 가져오기
  useEffect(() => {
    if (!isSharedView) return;

    getSharedUserData(sharedKeyCode).then((user) => {
      if (user) setSharedUserData(user);
    });
  }, [sharedKeyCode]);

  const displayName = isSharedView
    ? (sharedUserData?.get("user_name") ?? "-") // 공유링크: DB값
    : playerName; // 직접접근: GameContext값

  /* =========================
     공유 버튼 (기존 유지)
  ========================= */
  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(
        `${window.location.origin}/clear?code=${playerKeyCode}`,
      );
      alert("URL이 클립보드에 복사되었습니다.");
    } catch (e) {
      alert("복사에 실패했습니다.");
    }
  };

  return (
    <div id="content">
      {!isSharedView && <Header />}

      <div className="box content_box1 ans0001 clearBox">
        <div className="box_con con_box1 con_pd5 con_box_c">
          <div className="mission_tit clearTit mt8"></div>

          <div className="clear_malangImg mt50">
            <img src={malangImg} alt="말랑이" />
          </div>

          <div className="clearInfoBox mt16">
            <p className="clearTxt mt24">
              {displayName}님 <br />
              미션 완료를 축하합니다!
            </p>
          </div>

          {/* ✅ 공유링크 접근 시 버튼 숨김 */}
          {!isSharedView && (
            <div className="mt80">
              <button
                type="button"
                className="inputBtn02 btnCode"
                onClick={handleShare}
              >
                미션완료 링크 공유하기
              </button>
              <button
                type="button"
                className="inputBtn02 btnCode mt16"
                onClick={() => navigate("/")}
              >
                처음으로 돌아가기
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
